import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import './NotFound.css';

const NotFound = () => {
    return (
        <>
            <Helmet>
                <title>404 - Page Not Found | AT Architects</title>
                <meta name="description" content="The page you're looking for doesn't exist." />
            </Helmet>

            <section className="notfound-section">
                <div className="notfound-container">
                    <motion.div
                        className="notfound-content"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <motion.h1
                            className="notfound-title"
                            initial={{ scale: 0.5 }}
                            animate={{ scale: 1 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                        >
                            404
                        </motion.h1>
                        <h2 className="notfound-subtitle">Page Not Found</h2>
                        <p className="notfound-description">
                            Oops! The page you're looking for doesn't exist or has been moved.
                        </p>
                        <Link to="/" className="notfound-btn">
                            <i className="bi bi-house-door"></i>
                            Back to Home
                        </Link>
                    </motion.div>
                </div>
            </section>
        </>
    );
};

export default NotFound;
